export const ordinalSuffixOf = (number: number) => {
  const decades = number % 10;
  const hundreds = number % 100;
  if (decades === 1 && hundreds !== 11) {
    return `${number}st`;
  }
  if (decades === 2 && hundreds !== 12) {
    return `${number}nd`;
  }
  if (decades === 3 && hundreds !== 13) {
    return `${number}rd`;
  }
  return `${number}th`;
};
